import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkPreloadingStrategyService implements PreloadingStrategy {

  preload(route: Route, load: () => Observable<any>): Observable<any> {

    // If we supplied the preload parameter, then preload based off the boolean value
    if (route.data != undefined && route.data["preload"] === true) {
      return load();
    } else if (route.data != undefined && route.data["preload"] === false) {
      return of(null);
    }

    // If the preload parameter was not supplied, let's attempt to preload based on the user's network
    // If good connection, then preload, otherwise do not.
    const network = (navigator as any).connection;

    if (network != undefined) {
      if (network.saveData != undefined && network.saveData === true) {
        return of(null);
      }

      var speed = network.effectiveType;
      var slowConnections = ['slow-2g', '2g'];
      if (slowConnections.includes(speed)) {
        return of(null);
      }

      return load();
    }

    return of(null);
  }
}
